import {urlValidation, loader, message, errorHandler, logout} from '@/libs/helper'
import {isEmpty, cloneDeep} from 'lodash'
import {scrapPublication} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
export default {
    name: 'AddArticle',
    props:{
        stepBack: {
            type: Function,
            default: ()=>{}
        },
        stepForward: {
            type: Function,
            default: ()=>{}
        },
        cancel: {
            type: Function,
            default: ()=>{}
        },
        showButtons: {
            type: Boolean,
            default: ()=> true
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        setClaimTo: {
            type: Function,
            default: ()=> {}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        isStepBack: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        userData: {
            type: Object,
            default: ()=>{}
        },
        adminEditButtons: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        claimTo (newValue) {
            this.urls = newValue.url || [],
            this.card = {
                url: newValue.previous_url || ''
            }
            this.domain = newValue.domain || ''
        }
    },
    data() {
        return {
            card: {
                url: this.claimTo.previous_url || ''
            },
            urlValidation,
            domain: this.claimTo.domain || '',
            urls: this.claimTo.url || [],
            urlValidate: function (rule, value, callback) {
                if (isEmpty(value)) callback(new Error('Field should not be empty')) 
                if (value && value !== '' && (value.includes('http://') || value.includes('https://'))) callback(new Error('Try adding url without web protocols(http or https)'))
                if (!urlValidation('https://' + value)) callback(new Error('Incorrect url')) 
                else callback()
            },
            publicationDomainValidation: function (rule, value, callback) {
                if (isEmpty(value)) callback(new Error('Field should not be empty'))

                if (!urlValidation(`https://${this.domain}/${value}`)) callback(new Error('Incorrect url')) 
                else callback()
            }
        }
    },
    methods: {
        submit (module) {
            switch (module) {
                case constants.AUTHOR.key:
                    this.submitAuthor()
                break
                case constants.PUBLICATION.key:
                    this.submitPublication()
                break
            }
        },
        /**
         * to scrap the article with author 
         * and get the record from the api
         */
        submitAuthor: async function () {
            // validate the form
            this.$refs['articleURL'].validate(async(valid) => {
                try {
                    if(!valid){
                        return
                    }
                    if (this.card.url === this.claimTo.previous_url) {
                        this.stepForward()
                        return
                    }
                    loader(this, true)

                    // body for api call
                    let body = {
                        url: `https://${this.card.url}`
                    }
                    // api call
                    let response = await scrapPublication(this.module.toLowerCase(), body)
                    let claimTo = this.claimTo
                    // conditions on which to save the field and then go to next step
                    if (response.success && !isEmpty(response.items) && response.items.authors && !isEmpty(response.items.authors)) {
                        claimTo.first_name = response.items.authors[0].first_name || ''
                        claimTo.middle_name = response.items.authors[0].middle_name || ''
                        claimTo.last_name = response.items.authors[0].last_name || ''
                        claimTo.name = response.items.authors[0].name || ''
                        claimTo._id = response.items.authors[0]._id || ''
                        claimTo.previous_url = this.card.url
                        // next step
                        this.stepForward()

                    } else {
                        // failed condition to show the error message
                        message(this, constants.messageType.ERROR, 'Not able to scrap author')
                    }
                    loader(this, false)
                } catch (error) {
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                }
            })
        },

        /**
         * to scrap the article with author 
         * and get the record from the api
         */
        submitPublication: async function () {
            try {
                let url = cloneDeep(this.card.url)
                if (url !== '' && url.length > 1 && url.charAt(0) === '/') {
                    url = url.slice(1)
                }
                if (this.domain === this.claimTo.domain && url === this.claimTo.previous_url) {
                    this.stepForward()
                    return
                }
                loader(this, true)
                // body for api call
                let body = {
                    url: `https://${this.domain}/${url}`
                }
                // api call
                let response = await scrapPublication(this.module.toLowerCase(), body)
                let claimTo = this.claimTo
                if (response.success && !isEmpty(response.items) && response.items.publication && !isEmpty(response.items.publication)) {
                    claimTo.name = response.items.publication.name || ''
                    claimTo._id = response.items.publication._id || ''
                    claimTo.previous_url = url
                    claimTo.domain = this.domain
                    // next step
                    this.stepForward()

                } else {
                    // failed condition to show the error message
                    message(this, constants.messageType.ERROR, 'Not able to scrap author')
                }
                loader(this, false)
            } catch (error) {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        isDisabled () {
            if (this.module === constants.PUBLICATION.key && this.card.url !== '' && this.domain !== '') return false
            if (this.module === constants.AUTHOR.key && this.card.url !== '') return false
            return true
        }
    }
}